"use client"
import React, { useState, useEffect } from "react";
import { BrowserView } from 'react-device-detect';
// import toast, { Toaster } from 'react-hot-toast';
import { isLoggedIn } from "@/app/funcs/api";
import { loginUser, loginUserGoogle, checkUserExists } from "@/app/funcs/auth";
import registerUser, { registerUserNormal, registerUserGoogle } from "@/app/funcs/auth";
import { showHidePass1 } from "@/app/funcs/funcs";
import Image from 'next/image';
import welcomeImage from '@/app//assets/images/welcome.webp';
import { useRouter } from "next/navigation";

import { GoogleOAuthProvider, useGoogleOneTapLogin, GoogleLogin, googleLogout } from "@react-oauth/google";
import googleOneTap from "google-one-tap";
// import jwt_decode from 'jwt-decode';
import { jwtDecode } from "jwt-decode";
import { toast } from 'react-toastify';



export default function SignUpPage() {
    const router = useRouter();
    const [yourName, setYourName] = useState(null);
    const [formData, setFormData] = useState({ email: "", username: "", password: "", name: null, first_name: null, nickname: null, display_name: null });
    const [message, setMessage] = useState(null);
    const [isSubmit, SetisSubmit] = useState(false);
    const [isSucess, SetisSucess] = useState(false);
    const [isValid, SetisValid] = useState(true);
    // const notify = (msg, type) => { type ? toast.success(msg) : toast.error(msg) };

    const oneTap = () => {
        useGoogleOneTapLogin({
            onSuccess: (response) => {
                console.log("Login Successful:", response);
                // Handle successful login here
            },
            onError: (error) => {
                console.error("Login Failed:", error);
                // Handle login failure here
            },
            client_id: "972759779991-rtjp4vb13bosiv282b7nmc8tas99okae.apps.googleusercontent.com", // Replace with your Google Client ID
        });
    };

    // Handle Logout
    const handleLogout = () => {
        googleLogout(); // Logs out the Google session
        if (user) setUser(null); // Clear user state
        localStorage.removeItem("token"); // Remove invalid token
        console.log("User logged out");
    };

    // ---------------------------- //

    useEffect(() => {
        console.log(isLoggedIn());
        isLoggedIn() === true ? router.push('/account') : '';
    }, [])


    function extractUsername(email) {
        console.log('extractUsername is:', email.split("@")[0]);
        return email.split("@")[0];
    }

    useEffect(() => {
        console.log("Updated yourName from parent:", yourName);
        let getLocalStoredUser = localStorage.getItem('user');
        console.log(getLocalStoredUser)
        getLocalStoredUser = JSON.parse(getLocalStoredUser)
        getLocalStoredUser = { ...getLocalStoredUser, name: yourName }
        getLocalStoredUser = JSON.stringify(getLocalStoredUser);
        console.log(getLocalStoredUser)
        localStorage.setItem("user", getLocalStoredUser);
    }, [yourName]);

    const handleChange = (e) => {
        console.log(e.target.name + ' : ' + e.target.value);

        if (e.target.name == "name") {
            setYourName(e.target.value);
            setFormData({ [e.target.name]: e.target.value, first_name: e.target.value, nickname: e.target.value, display_name: e.target.value });
        } else if (e.target.name === "email") {
            console.log(e.target.name + ' : ' + e.target.value)
            setFormData({ [e.target.name]: e.target.value, username: extractUsername(e.target.value), name: yourName, first_name: yourName, nickname: yourName, display_name: yourName });
            console.log(JSON.stringify(formData))
        } else {
            setFormData({ ...formData, [e.target.name]: e.target.value });
        }
    };

    const clearStorage = () => {
        localStorage.removeItem('user');
        location.reload();
    }

    // Handle Google Login Success
    const handleSuccess = async (credentialResponse) => {
        try {
            const token = credentialResponse.credential;
            const userInfo = token ? jwtDecode(token) : null;
            if (!userInfo) throw new Error("Google token decode failed");

            const { email, name, given_name, family_name, picture } = userInfo;

            // 1. Try to login with Google first (regardless of whether user exists)
            try {
                const loginData = await loginUserGoogle(email);
                // const loginData = await loginUserGoogle(token);
                localStorage.setItem("token", loginData.token);
                localStorage.setItem("user", JSON.stringify(loginData));
                toast.success("تم تسجيل الدخول بنجاح عبر Google!");
                router.push('/account');
            } catch (loginErr) {
                // If Google login fails, check if user exists
                const userExists = await checkUserExists(email);

                if (userExists) {
                    // User exists but Google login failed (probably different password)
                    toast.error(
                        <>
                            هذا البريد مسجل بكلمة مرور مختلفة.<br />
                            يمكنك ربط حساب Google الخاص بك من صفحة <a href="/account/">حسابك</a> بعد تسجيل الدخول بالطريقة العادية.
                        </>
                    );
                } else {
                    // User doesn't exist, register and login
                    try {
                        await registerUserGoogle({
                            email,
                            username: email.split("@")[0],
                            password: email + "_google_secret",
                            name: name || given_name,
                            first_name: given_name,
                            last_name: family_name,
                            display_name: name,
                        });

                        // Login after registration
                        const loginData = await loginUserGoogle(email);
                        localStorage.setItem("token", loginData.token);
                        localStorage.setItem("user", JSON.stringify(loginData));
                        toast.success("تم إنشاء حسابك وتسجيل الدخول بنجاح عبر Google!");
                        router.push('/account');
                    } catch (regErr) {
                        toast.error("فشل إنشاء الحساب عبر Google: " + regErr.message);
                    }
                }
            }


        } catch (err) {
            toast.error("فشل تسجيل الدخول عبر Google: " + err.message);
            console.error(err);
        }
    };
    // Handle Logout
    const handleSubmit = async (e) => {

        console.log(JSON.stringify(formData))
        SetisSubmit(true);
        e.preventDefault();
        setMessage(null);
        try {
            const data = await registerUserNormal(formData);
            // setMessage("🎉 تم إنشاء حسابك بنجاح");
            // notify("🎉 تم إنشاء حسابك بنجاح", 1);
            toast.success("🎉 تم إنشاء حسابك بنجاح")
            SetisSubmit(false);
            SetisSucess(true);
            SetisValid(true);
            // Store token  in local storage 
            let getLocalStoredUser = localStorage.getItem('user');
            // console.log(getLocalStoredUser)
            getLocalStoredUser = JSON.parse(getLocalStoredUser)
            getLocalStoredUser = { ...getLocalStoredUser, token: 1 }
            getLocalStoredUser = JSON.stringify(getLocalStoredUser);
            console.log(getLocalStoredUser)
            localStorage.setItem("user", getLocalStoredUser);
        } catch (err) {
            // setMessage("❌" + ` ${err.message} , وتأكد من صحة اسم المستخدم والبريد الإلكتروني`);
            // notify(` ${err.message} , وتأكد من صحة اسم المستخدم والبريد الإلكتروني`, 0);
            console.error(err);
            setMessage(`❌ ${err.message}`);
            toast.error("تأكد من صحة اسم المستخدم والبريد الإلكتروني")
            // notify(`تأكد من صحة اسم المستخدم والبريد الإلكتروني`, 0);
            SetisSubmit(false);
            SetisSucess(false);
            SetisValid(false);
        }
    };

    return (
        <>
            {/* <oneTap></oneTap> */}
            {/* <OnTapYaNas></OnTapYaNas> */}


            <div className="mt-4 col-12 col-md-8 col-xl-4 bg-white pb-3 bg-white rounded-4 p-4 mx-auto  shadow-sm">
                <div id="WeclomeToFigmawya" className={`${!isSucess ? 'd-none' : 'd-block alert alert-success text-center w-fit mx-auto border-0 mb-0'}`}>
                    <Image src={welcomeImage} alt="welcome" className="img-fluid mx-auto my-3" width={80} />
                    <h4 className="alert-heading fs-4">أهلاً يا  <mark className="d-inline-block">{yourName}</mark> في عائلة فيجماوية 🥰</h4>
                    <p className="mb-0 fs-5">من فضلك تأكد من استلام رسالة الترحيب في بريدك الإلكتروني</p>
                    <p className="mb-0 fs-5 small">في حالة لم تجد الرسالة في صندوق البريد تأكد من البريد المزعج أو Spam أو junk</p>
                    <span className={`${!isSucess ? 'd-none' : 'd-block w-fit mx-auto mt-4 btn btn-outline-dark'}`} onClick={clearStorage}><i className="bi bi-arrow-clockwise"></i> إعادة تعيين وإنشاء حساب جديد </span>
                </div>

                <div className={`${isSucess ? 'd-none' : ''} newUserForm`}>

                    {/* <form id="ActionForm" onSubmit={handleSubmit} method="post" className={`mx-auto text-start`}>
                        <h1 className={`mb-1 border-bottom pb-4 mb-4 lh-1`}>إنشاء حساب جديد</h1>
                        <div className="col-12 py-1">
                            <label for="exampleInputName" className="form-label">إسمك</label>
                            <input type="text" name="name" className="form-control" id="exampleInputName" value={yourName} onChange={handleChange} aria-describedby="nameHelp" required />
                            <div className="valid-feedback">
                                Looks good!
                            </div>
                        </div>


                        <div className="col-12 py-1">
                            <label for="exampleInputEmail1" className="form-label">بريدك الإلكتروني *</label>
                            <input type="email" className={`${!isValid ? 'is-invalid' : null} form-control`} id="exampleInputEmail1" aria-describedby="emailHelp" name="email" required autoComplete onChange={handleChange} />
                            <BrowserView>   <div id="emailHelp" className="form-text"><small>بريد الكتروني انت متعود تستخدمه دايماً علشان لو هنتواصل معاك لأي سبب نكون ضامنين انك هتعرف توصل ليه </small></div></BrowserView>
                        </div>

                        <div className={`col-12 py-1 pos-relative`}>
                            <label for="exampleInputPassword1" className="form-label">كلمة المرور *</label>
                            <input type="password" id="password1" className="form-control" name="password" required onChange={handleChange} />
                            <i className="showHidePass bi bi-eye-slash" id="togglePassword1" onClick={showHidePass1}></i>
                            <BrowserView>  <div id="emailHelp" className="form-text"><small>ممكن تكون أي حاجة ، تقدر تغيرها بعدين</small></div></BrowserView>
                        </div>


                        <button type="submit" className="mt-2 btn btn-primary col-12" disabled={isSubmit}> <span className={`spinner-border spinner-border-sm ${!isSubmit ? 'd-none' : null}`} role="status" aria-hidden="true"></span> {isSubmit ? 'ثواني من فضلك ... ' : 'تسجيل حسابي'}</button>
                    </form>

                    <hr /> */}
                    <p className='text-center mx-auto'> انشاء حساب عن طريق جووجل</p>
                    <GoogleOAuthProvider clientId="972759779991-rtjp4vb13bosiv282b7nmc8tas99okae.apps.googleusercontent.com">
                        <div className="w-100">
                            <GoogleLogin
                                theme='filled_black'
                                size='large'
                                type='standard'
                                shape='pill'
                                width={380}
                                onSuccess={handleSuccess}
                                onError={() => {
                                    console.log("Login Failed");
                                }}
                                useOneTap={true}
                                style={{ width: '100%' }}
                            />
                        </div>
                    </GoogleOAuthProvider>
                </div>
            </div>
            {/* --/ New User Form */}
        </>
    );

}